export default __webpack_public_path__ + "static/media/man-banner-thanks-mobile.cfc84d7b.png";